import { useEffect, useState } from 'react'
import { AlertTypeEnums } from '../common/constants'
import { api } from '../services'
import { Spinner } from './Spinner'

interface AlertControlItem {
  alertType: AlertTypeEnums
  enabled: boolean
}

interface Props {
  advancedMode: boolean
}

export function UserSettingsAlertControls({ advancedMode }: Props) {
  const [isLoading, setIsLoading] = useState(false)
  const [settings, setSettings] = useState([
    {
      alertType: AlertTypeEnums.SENSOR_ALERTS,
      type: 'Sensor Alert',
      enabled: false,
    },
    {
      alertType: AlertTypeEnums.SYSTEM_CONTROL_MESSAGES,
      type: 'System Control Messages',
      enabled: false,
    },
    {
      alertType: AlertTypeEnums.TEST_MESSAGES,
      type: 'Test Messages',
      enabled: false,
    },
  ])

  useEffect(() => {
    setIsLoading(true)
    api
      .getAlertControls()
      .then((result) => {
        const updatedSettings = settings.map((setting) => {
          const item = result.find((item: AlertControlItem) => item.alertType === setting.alertType)

          if (item) {
            setting.enabled = item.enabled
          }
          return setting
        })

        setSettings(updatedSettings)
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setIsLoading(false)
      })

    return () => {}
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function updateSettings(alertType: string, enabled: boolean) {
    setSettings(
      settings.map((setting) => {
        if (setting.alertType === alertType) {
          setting.enabled = enabled
        }
        return setting
      })
    )

    setIsLoading(true)

    api
      .updateAlertControls({ alertType, enabled })
      .then(() => {})
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return (
    <div className="mb-10">
      <div className={tailwind.header}>
        Alert Controls
        <div className="pt-1">{isLoading && <Spinner size={20} color="white" />}</div>
      </div>
      <table className={tailwind.table}>
        <tbody>
          {settings.map((setting, index) => {
            if (!advancedMode && setting.alertType !== AlertTypeEnums.SENSOR_ALERTS) {
              return null
            }

            return (
              <tr key={index} className="h-8">
                <td className={tailwind.checkbox}>
                  <input
                    type="checkbox"
                    checked={setting.enabled}
                    onChange={() => updateSettings(setting.alertType, !setting.enabled)}
                  />
                </td>
                <td className={tailwind.label}>{setting.type}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

const tailwind = {
  header: 'flex flex-auto justify-between text-black text-l font-regular bg-[#BBB] py-2.5 pl-4 pr-4 w-full mb-4',
  table: 'w-full mx-3',
  inputText:
    'appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none',
  checkbox: 'px-3 w-[10px]',
  label: 'align-left ml-2',
  alertContactInput: 'w-1/4',
  icon: 'pl-3',
}
